import React from "react";
import ReportPage from "./ReportPage";

export default function PensionReports() {
  return (
    <ReportPage
      title="Pension Reports"
      subtitle="Employee and employer pension schedule."
      endpoint="/reports/pension"
      exportName="pension"
      summaryCards={[
        { key: "employee_pension", label: "Employee Pension", money: true },
        { key: "employer_pension", label: "Employer Pension", money: true },
      ]}
      columns={[
        { key: "pf_no", label: "PF No" },
        { key: "fullname", label: "Name" },
        { key: "pfa", label: "PFA" },
        { key: "rsa_pin", label: "RSA PIN" },
        { key: "employee_pension", label: "Employee Pension" },
        { key: "employer_pension", label: "Employer Pension" },
        { key: "total_pension", label: "Total" },
      ]}
    />
  );
}
